import { DCSPEventSubTypes } from '../../../../interfaces/RFXRequestForm';

/**
 * Check whether the event sub type of DCSP general information is valid
 */
export function isValidEventSubtype(eventSubType: string) {
  return Object.values(DCSPEventSubTypes).includes(eventSubType);
}
